import * as React from 'react';
import { Col, Row } from 'antd';
import { Prompt } from 'react-router';

import { TabLanguageController } from 'src/core/ui/language/tab-language.controller';
import { BooleanView } from 'src/core/ui/boolean.view';
import { CardController } from 'src/app/shared/card.controller';
import { HeaderView } from 'src/app/shared/header.view';
import { ProductCategoryEditorController } from 'src/app/products/product-categories/parts/product-category-editor.controller';
import { ProductTypeEditorController } from '../../products/parts/product-type-editor.controller';
import { ProductServiceTypeListController } from '../../product-service-types/list/product-service-type-list.controller';
import { TaxonomicFieldList } from 'src/app/products/product-categories/form/parts/taxonomic-field-list';

interface ProductCategoryFormViewProps extends ComponentViewProps<ProductCategoryItem> {
	title: string,
	save: () => void,
	cancel: () => void,
	model: ProductCategoryItem;
	mode: ControlMode;
	onModeChange: (mode: ControlMode) => void;
	contextService: any;
	defaultLanguage: string;
}

export class ProductCategoryFormView extends React.Component<ProductCategoryFormViewProps, {}> {
	constructor(props: Readonly<ProductCategoryFormViewProps>) {
		super(props);
	}

	render(): React.ReactNode {
		const { mode, model } = this.props;
		const displayNames = model.dynamicProperties['displayName'];
		const array: TabLanguageModel[] = [{ title: 'Title', dynamicProperties: displayNames, required: true }];

		return (
			<div className="window window-normal">
				<Prompt
					when={this.props.contextService.isDirty}
					message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
				/>
				<Row>
					<Col xs={24} lg={{ offset: 4, span: 16 }}>
						<Row>
							<Col xs={24}>
								<HeaderView
									title={this.props.title}
									mode={this.props.mode}
									onModeChanged={this.props.onModeChange}
									save={this.props.save}
									cancel={this.props.cancel}
									contextService={this.props.contextService}
								/>
							</Col>
						</Row>
						{
							model != null &&
							<Row>
								<Col xs={24}>
									<div className="card p-3">
										<Row gutter={16}>
											<Col xs={24}>
												<CardController
													mode={this.props.mode}
													icon="book"
													className="card-borderless"
													title="General information">
													<Row gutter={16}>
														<Col span={24}>
															<TabLanguageController
																dynamicProperties={array}
																mode={mode}
																setBusy={this.props.setBusy}
																isRichTextBox={false}
																model={this.props.model}
															/>
														</Col>
														<Col span={24}>
															<ProductCategoryEditorController
																baseCategoriesEnabled
																label="Parent category"
																mode={mode}
																onChanged={(value) => { model.parentCategoryId = value != null ? value.id : null }}
																value={model.parentCategoryId}
																setBusy={this.props.setBusy}
															/>
														</Col>
														<Col xs={24} lg={12}>
															<ProductTypeEditorController
																label="Can Have Children of Type"
																mode={mode}
																onChanged={(value) => { model.canHaveChildrenOfType = value }}
																value={model.canHaveChildrenOfType}
																setBusy={this.props.setBusy}
															/>
														</Col>
														<Col xs={24} lg={12}>
															<ProductTypeEditorController
																mode={mode}
																required
																onGetErrorMessage={() => this.props.model.validate(false, 'productType')}
																onChanged={(value) => { model.productType = value }}
																value={model.productType}
																setBusy={this.props.setBusy}
															/>
														</Col>
														<Col xs={24} lg={12}>
															<BooleanView
																label="Can Have Contracts"
																mode={mode}
																onChanged={(value) => {
																	model.canHaveContracts = value;
																	this.forceUpdate();
																}}
																value={model.canHaveContracts}
															/>
														</Col>
														<Col xs={24} lg={12}>
															<BooleanView
																label="Can Have Supplements Or Discounts"
																mode={mode}
																onChanged={(value) => {
																	model.canHaveSupplementsOrDiscounts = value;
																	this.forceUpdate();
																}}
																value={model.canHaveSupplementsOrDiscounts}
															/>
														</Col>
													</Row>
												</CardController>
											</Col>
											<Col xs={24}>
												<ProductServiceTypeListController
													defaultLanguage={this.props.defaultLanguage}
													contextService={this.props.contextService}
													mode={this.props.mode}
													onModeChanged={this.props.onModeChange}
													setBusy={this.props.setBusy}
													category={model}
												/>
											</Col>
											<Col xs={24}>
												<TaxonomicFieldList
													entityName="product"
													model={model}
													mode={this.props.mode}
													setBusy={this.props.setBusy}
													/>
											</Col>
										</Row>
									</div>
								</Col>
							</Row>
						}
					</Col>
				</Row>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/product-categories/form/product-category-form.view.tsx